// API base URL — prod'a alırken burası değiştirilecek
const API_URL = 'https://qapi.qarint.com/';

export default API_URL;
 